import { Typography } from '@mui/material';
import React from 'react';

import IntermediateResultsDownloadModal from 'components/StudiesDashboard/StudyExportMenu/IntermediateResultsDownloadModal';
import { ExportScopeFields, ExportScopeValue } from './ExportFormFields';
import { ExportFormShell } from './ExportFormShell';
import { getCasesFieldLabel, getScopeOptionLabels } from './exportScopeLabels';
import { ResultsExportContext } from './useResultsExportContext';

interface IntermediateOutputsExportFormProps {
  context: ResultsExportContext;
  onBack: () => void;
}

export const IntermediateOutputsExportForm: React.FC<IntermediateOutputsExportFormProps> = ({ context, onBack }) => {
  const [isChooserOpen, setIsChooserOpen] = React.useState(false);
  const units = context.isSlidesMode ? 'slides' : 'cases';

  return (
    <>
      <ExportFormShell
        study={context.study}
        scope={
          <ExportScopeFields>
            <ExportScopeValue
              label={getCasesFieldLabel(context.isSlidesMode)}
              note="Follows the current Dataset selection."
            >
              {getScopeOptionLabels(context.isSlidesMode).selected}
            </ExportScopeValue>
            <ExportScopeValue label="Results">Listed per job run, not per publication state.</ExportScopeValue>
          </ExportScopeFields>
        }
        options={
          <Typography variant="body2" color="text.secondary">
            Choose individual job results to download in the next step.
          </Typography>
        }
        primaryLabel="Choose job results"
        primaryDisabled={!context.hasIntermediateResultsSelection}
        primaryGuidance={`Select specific ${units} first.`}
        onPrimary={() => setIsChooserOpen(true)}
        onBack={onBack}
      />
      {isChooserOpen && <IntermediateResultsDownloadModal open onClose={() => setIsChooserOpen(false)} />}
    </>
  );
};
